import {useRef, useState} from 'react'

export const useFakeProgress = () => {
  const [fakeProgress, setfakeProgress] = useState(0)
  const progressRef = useRef(30)

  const getFakeProgress = () => {
    return new Promise(resolve => {
      const intervalID = setInterval(() => {
        if (progressRef.current >= 100) {
          clearInterval(intervalID)
          setfakeProgress(100)
          resolve(progressRef.current)
        } else {
          setfakeProgress(progressRef.current)
          progressRef.current = progressRef.current + 10
        }
      }, 200)
    })
  }
  return {
    getFakeProgress,
    fakeProgress,
  }
}
